var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardRuntimeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#084032"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.3,91.6) scale(1.537)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.147 117.212 90.944 149.425A2 2 0 0 1 88 147.662v-17.249c0-.714.381-1.374.999-1.732l33.72-19.491a2 2 0 0 0 .052-3.432L88.947 84.81A2 2 0 0 1 88 83.11V66.418a2 2 0 0 1 2.98-1.743l60.422 33.956a11.5 11.5 0 0 1 1.905 1.517 11.5 11.5 0 0 1 .301 15.002l-.161.193a7.7 7.7 0 0 1-2.3 1.869Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.147 117.212-60.203 32.213A2 2 0 0 1 169 147.662v-17.249c0-.714.381-1.374.999-1.732l33.72-19.491a2 2 0 0 0 .052-3.432L169.947 84.81A2 2 0 0 1 169 83.11V66.418a2 2 0 0 1 2.98-1.743l60.422 33.956a11.5 11.5 0 0 1 1.905 1.517 11.5 11.5 0 0 1 .301 15.002l-.161.193a7.7 7.7 0 0 1-2.3 1.869Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 185v-3.665a5 5 0 0 0-5-5H59.856a15 15 0 0 1-15-15V52.665a15 15 0 0 1 15-15H74a5 5 0 0 0 5-5V29a5 5 0 0 0-5-5H53a22 22 0 0 0-22 22v122a22 22 0 0 0 22 22h21a5 5 0 0 0 5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238 185v-3.665a5 5 0 0 1 5-5h14.144a15 15 0 0 0 15-15V52.665a15 15 0 0 0-15-15H243a5 5 0 0 1-5-5V29a5 5 0 0 1 5-5h21a22 22 0 0 1 22 22v122a22 22 0 0 1-22 22h-21a5 5 0 0 1-5-5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardRuntimeLogo);
export default __webpack_public_path__ + "static/media/forward_runtime_logo.43475c54cfce6a7b9a66873136f11b4f.svg";
export { ForwardRef as ReactComponent };